import React from 'react'
import InputGroup from './InputGroup.jsx'
import PropTypes from 'prop-types'

function Step1FP({
  compact,
  handleInputChange,
  handleFirmInputChange,
  formValidation,
  firms,
  nextButton,
}) {
  function renderFirms() {
    return firms.length > 0 ? (
      <datalist id="firms">
        {firms.map((firm, index) => {
          return <option value={firm.firmNm} key={'' + index + firm.firmId} />
        })}
        ;
      </datalist>
    ) : null
  }

  return (
    <div className="u-paddingHoriz6gu u-sm-sizeFull">
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        fieldName="firstName"
        fieldId="firstName"
        label="First Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        fieldName="lastName"
        fieldId="lastName"
        label="Last Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleFirmInputChange}
        formValidation={formValidation}
        fieldName="firmName"
        fieldId="firmName"
        label="Firm Name"
        list="firms"
        compact={compact}
        disableAutoComplete={true}
      />
      {renderFirms()}
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        fieldName="emailId"
        fieldId="emailId"
        label="Firm Email Address"
        compact={compact}
      />
      {nextButton && nextButton()}
    </div>
  )
}

Step1FP.propTypes = {
  compact: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  handleFirmInputChange: PropTypes.func.isRequired,
  formValidation: PropTypes.object,
  firms: PropTypes.array,
  nextButton: PropTypes.func,
}

export default Step1FP
